// extracted by mini-css-extract-plugin
export default {"wrapper":"BonusHunterBlock_wrapper--Egm","image":"BonusHunterBlock_image--cWc"};